import { buildValidator } from "./buildValidator";

export const date = buildValidator("You can find this date in My Activity", (value, input) => {
  const rsRequired = input?.getAttribute("rsrequired");
  if (rsRequired && /\{val:false,/.test(rsRequired) && !value) {
    return true;
  }
  return (
    !!value &&
    typeof value === "string" &&
    Date.parse(`${value}T00:00:00`) <
      Date.parse(
        `${new Date().toLocaleDateString("en-US", { year: "numeric" })}-${new Date().toLocaleDateString("en-US", {
          month: "2-digit",
        })}-${new Date().toLocaleDateString("en-US", { day: "2-digit" })}T00:00:00`
      )
  );
});
